const PERMISSION_LEVELS = {
    ALL: 8,
    ONLY_YOUR_AREA: 4,
    ONLY_YOURS: 2,
    NONE: 0,
};

export default PERMISSION_LEVELS;
